module.exports = __webpack_public_path__ + "static/media/skyscout-monocular-1.0945f7ae.jpg";